import { AuditoriaOTInstallDocsFormTab } from '@/erp/operaciones/auditoria/instalaciones/shared/components';
import { tabTextLabelSx } from '@/shared';
import { TabTextLabel } from '@/shared/components/ui';
import { Contrato, OrdenTrabajo } from '@/shared/interfaces';
import { ClienteFibraPromocionesFormTab } from '../promociones';

export type ClienteFibraDocsFormTabProps = {
  contract: Contrato;
};

const ClienteFibraDocsFormTab: React.FC<ClienteFibraDocsFormTabProps> = ({
  contract,
}) => {
  if (!contract) return null;

  return (
    <>
      <TabTextLabel
          text="Promoción Cliente Fibra"
          sx={{
            ...tabTextLabelSx,
            pb: '3px',
            pt: '54px',
            mt: '0px',
          }}
      />
      <ClienteFibraPromocionesFormTab
        contract={contract}
      />
      <AuditoriaOTInstallDocsFormTab
        contrato={contract}
        ordenTrabajo={
          {
            ...(contract?.orden_trabajo_data || {}),
            contrato_data: contract,
            preventa_data: contract?.preventa_data || {},
          } as OrdenTrabajo
        }
      />
    </>
  );
};

export default ClienteFibraDocsFormTab;
